import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { BLOG_INDEX, BLOG_POSTS } from '../data/blogPosts';
import '../styles/Blog.css';

const formatDate = (iso) => {
  try {
    return new Date(`${iso}T12:00:00`).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return iso;
  }
};

const Blog = () => {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        name: BLOG_INDEX.heading,
        description: BLOG_INDEX.description,
        url: `https://easydroptaxi.com${BLOG_INDEX.path}`,
        publisher: {
          '@type': 'Organization',
          name: 'Easy Drop Taxi',
          url: 'https://easydroptaxi.com/',
        },
        blogPost: BLOG_POSTS.map((post) => ({
          '@type': 'BlogPosting',
          headline: post.heading,
          description: post.description,
          datePublished: post.publishedAt,
          dateModified: post.updatedAt,
          url: `https://easydroptaxi.com${post.path}`,
        })),
      },
    ],
    []
  );

  return (
    <main className="blog-page">
      <SeoHead
        title={BLOG_INDEX.title}
        description={BLOG_INDEX.description}
        path={BLOG_INDEX.path}
        jsonLd={jsonLd}
      />

      <section
        className="page-banner block-space text-white"
        style={{ backgroundColor: 'var(--secondary-color)' }}
      >
        <div className="container">
          <nav className="blog-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span> / Blog</span>
          </nav>
          <h1 className="display-4 fw-bold">{BLOG_INDEX.heading}</h1>
          <p className="lead mb-0">{BLOG_INDEX.intro}</p>
        </div>
      </section>

      <section className="block-space">
        <div className="container">
          <div className="blog-card-grid">
            {BLOG_POSTS.map((post) => (
              <Link key={post.slug} to={post.path} className="blog-card">
                <div className="blog-card-meta">{formatDate(post.publishedAt)}</div>
                <h2>{post.heading}</h2>
                <p>{post.description}</p>
                <span className="blog-card-cta">Read article →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Blog;
